import React, { useEffect, useMemo, useState } from 'react';
import useErrorHandling from '../../../hooks/useErrorHandling';
import { hideLoading, showLoading } from '../../../lib/uiService';
import AdminService from '../../../services/admin.service';
import ProductTabs from './Product';
import { useAuth } from '../../../providers/AuthProvider';
import { UserRole } from '../../../lib/types';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const ProductPricing: React.FC = () => {
  const { setError } = useErrorHandling();
  const { role } = useAuth();
  const [isFiltered, setIsFiltered] = useState(false);
  const [filterType, setFilterType] = useState<{ [key: string]: string }>({ brand: '' });
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10000);
  const [selectedObject, setSelectedObject] = useState<any>({ labelIsActive: true });
  const [editable, setEditable] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [products, setProducts] = useState([]);
  const [brandFamilies, setBrandFamilies] = useState([]);
  const [labels, setLabels] = useState([]);
  const [territories, setTerritories] = useState([]);
  const [statePrices, setStatePrices] = useState([]);
  const [brands, setBrands] = useState([]);
  const [productHasHistory, setProductHasHistory] = useState(false);
  const [productHistory, setProductHistory] = useState([]);
  const [initialStatePricesData, setInitialStatePricesData] = useState([]);
  const [relatedProducts, setRelatedProducts] = useState<any[]>([]);
  const [initialRelatedProducts, setInitialRelatedProducts] = useState<any[]>([]);
  const [searchParams] = useSearchParams();
  const paramProductHistoryGroupId = searchParams.get('phg');

  useEffect(() => {
    if (paramProductHistoryGroupId) {
      AdminService.GetProductHistoryGroup({ productHistoryGroupId: paramProductHistoryGroupId })
        .then(({ data }) => {
          if (data) {
            setStatePrices(data.priceHistory.sort((a: any, b: any) => a.name.localeCompare(b.name)));
            setInitialStatePricesData(data.priceHistory.sort((a: any, b: any) => a.name.localeCompare(b.name)));
            setEditable(true);
            setProductHasHistory(true);
          } else {
            toast.success('This product has already been aproved.');
          }
        })
        .catch((error) => {
          setError({ status: error.response.status || 500 });
        });
    }
  }, [paramProductHistoryGroupId]);

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    setDisabled(role?.includes(UserRole.ProductUser));
  }, [role]);

  const fetchProducts = async () => {
    showLoading();
    AdminService.GetBrandFamilysWithBrand()
      .then(({ data }) => {
        const brandFamiliesData = data.brands.map((brandFam: any) => {
          return {
            ...brandFam,
            value: brandFam.brandFamilyId,
            label: brandFam.brand.name + ' > ' + brandFam.name,
          };
        });
        setBrands(
          data.brands
            .map((item: any) => item.brand.name)
            .filter((value: any, index: number, self: any) => self.indexOf(value) === index),
        );
        setBrandFamilies(brandFamiliesData.sort((a: any, b: any) => a.label.localeCompare(b.label)));
      })
      .catch((error) => {
        console.log(error);
        setError({ status: error.response.status || 500 });
      });

    AdminService.GetLabelsWithBrand()
      .then(({ data }) => {
        const labelsData = data.labels.map((label: any) => {
          return {
            ...label,
            labelName: label.name,
            value: label.labelId,
            label: label.brandFamily.brand.name + ' > ' + label.name,
            brandId: label.brandFamily.brand.brandId,
          };
        });
        setLabels(labelsData.sort((a: any, b: any) => a.label.localeCompare(b.label)));
      })
      .catch((error) => {
        console.log(error);
        setError({ status: error.response.status || 500 });
      });
    try {
      const { data } = await AdminService.GetProductsAndLabels({
        page,
        pageSize,
      });
      const key = Object.keys(filterType)[0];
      const value = filterType[key].toLowerCase();
      const finalData = isFiltered
        ? data.products.filter((item: any) => item[key].toLowerCase().includes(value))
        : data.products.slice((page - 1) * pageSize, page * pageSize);
      setProducts(finalData);
      hideLoading();
    } catch (error: any) {
      console.log(error);
      setError({ status: error.response.status || 500 });
      hideLoading();
    }
  };

  return (
    <>
      <h3 className="text-dark mb-4">Product Pricing</h3>
      <ProductTabs
        editable={editable}
        setEditable={setEditable}
        selectedObject={selectedObject}
        setSelectedObject={setSelectedObject}
        labels={labels}
        territories={territories}
        setStatePrices={setStatePrices}
        initialStatePricesData={initialStatePricesData}
        statePrices={statePrices}
        fetchProducts={fetchProducts}
        products={products}
        brandFamilies={brandFamilies}
        brands={brands}
        productHasHistory={productHasHistory}
        setProductHasHistory={setProductHasHistory}
        productHistory={productHistory}
        setProductHistory={setProductHistory}
        relatedProducts={relatedProducts}
        setRelatedProducts={setRelatedProducts}
        initialRelatedProducts={initialRelatedProducts}
        setInitialRelatedProducts={setInitialRelatedProducts}
        disabled={disabled}
      />
    </>
  );
};

export default ProductPricing;
